module.exports = ".modal-dialog {\n  width: 80%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/serasa/component/serasa/relato-legado/relato-legado.component.scss
// module id = ./src/app/serasa/component/serasa/relato-legado/relato-legado.component.scss
// module chunks = main